import * as React from "react";
import { useState, useEffect, useContext } from "react";
import IGenericButtons from "../../Interfaces/IGenericButtons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import "./style.scss";
import Tooltip from "../../../Tooltip/Tooltip";
import { Modal } from "antd";
import ViewPendencyModal from "src/components/common/Pendency/ViewPendency/ViewPendencyModal";
import { ServiceContext } from "src/services/provider/Service.provider";
import { ShowNotification } from "src/components/common/ShowNotification/ShowNotification";
import IPendencyButton from 'src/services/interfaces/pendency/IPendencyButton';
import { ITradePendency } from 'src/services/interfaces/pendency/ITradePendency';

const ViewPendencyButton = (props: IPendencyButton & IGenericButtons) => {
  const [showModal, setShowModal] = useState<boolean>(false);
  const { pendencyService } = useContext(ServiceContext);
  const [pendencies, setPendencies] = useState<ITradePendency[]>([]);

  function GetTradePendencies() {
    pendencyService
      .getPendenciesByTradeId(props.trade.id)
      .then(resp => {
        setPendencies(resp);
      })
      .catch(() => {
        ShowNotification.Error("Tente novamente", "Falha ao buscar as pendencias do trade");
      });
  }

  useEffect(() => {
    if (showModal) {
      GetTradePendencies();
    } else {
      setPendencies([]);
    }
  }, [showModal]);

  return (
    <>
      <Tooltip text={"Visualizar pendências"}>
        <button className="archive btn" onClick={() => setShowModal(true)}>
          <FontAwesomeIcon icon={faCheck} />
          Visualizar pendências
        </button>
      </Tooltip>

      <Modal
        className="pendency-modal modal-large"
        title={"Visualizar Pendências"}
        visible={showModal}
        onCancel={() => setShowModal(false)}
        cancelText={"Fechar"}
        okText={"Ok"}
        onOk={() => setShowModal(false)}
      >
        {showModal && <ViewPendencyModal pendencies={pendencies} />}
      </Modal>
    </>
  );
};

export default ViewPendencyButton;



// WEBPACK FOOTER //
// ./src/components/common/GenericButtons/Pendency/ViewPendency/ViewPendencyButton.tsx